<template>
  <v-list dense class="nav-app-business">
    <!-- Mini -->
    <v-list-tile v-show="mini" @click="triggerOpen">
      <v-list-tile-action>
        <div class="text-truncate">{{ currentBusiness.name }}</div>
      </v-list-tile-action>
    </v-list-tile>
    <!-- NOT Mini -->
    <v-list-group v-show="!mini" v-model="open">
      <v-list-tile slot="activator">
        <v-list-tile-action>
          <!-- Le chevron du groupe ne laisse pas la place à la mention écrite: une icône et son
               infobulle la portent dans l'en-tête, la liste déroulante garde le texte. -->
          <v-tooltip v-if="isConsultationOnly(currentBusiness.id)" right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">visibility</v-icon>
            </template>
            <span>{{ $t('consultation-only-label') }}</span>
          </v-tooltip>
          <v-icon v-else>business</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ currentBusiness.name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="selectBusiness(business.id)" v-for="business in otherBusinesses" :key="business.id">
        <v-list-tile-action></v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-sub-title>{{ business.name }}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-if="isConsultationOnly(business.id)" class="caption">{{
            $t('consultation-only-label')
          }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
  </v-list>
</template>

<script>
import Company from '@/services/company'
import { Consts } from '@/helpers/consts'
import i18n from '@/helpers/i18n'

import gql from 'graphql-tag'

const GET_LOCAL_USER_CURRENT_COMPANY = gql`
  query LocalUserCurrentCompany {
    user @client {
      selectedCompany
    }
  }
`

export default {
  data: function () {
    return {
      isOpen: false
    }
  },
  props: {
    mini: {
      type: Boolean,
      required: true
    },
    me: {
      type: Object,
      required: false
    }
  },
  computed: {
    open: {
      get() {
        return this.mini ? false : this.isOpen
      },
      set(bool) {
        this.isOpen = this.mini ? false : bool
      }
    },
    isCurrentBusiness: function () {
      return (businessId) => {
        if (this.user && this.user.selectedCompany) {
          return this.user.selectedCompany === businessId
        }
        return false
      }
    },
    allBusinesses: function () {
      return this.me.recruiterOf.concat(this.me.recruiterReaderOf)
    },
    otherBusinesses: function () {
      return this.allBusinesses.filter((b) => !this.isCurrentBusiness(b.id))
    },
    currentBusiness: function () {
      const current = this.allBusinesses.filter((business) => this.isCurrentBusiness(business.id))
      return current[0] || { name: '' }
    },
    isConsultationOnly: function () {
      return (businessId) => this.me.recruiterReaderOf.some((business) => business.id === businessId)
    }
  },
  methods: {
    selectBusiness: async function (companyId) {
      await Company.updateCompanySelected(companyId)
      this.isGroupOpen = false
      this.$router.replace(i18n.getLocalizedUrl(Consts.URL_JOB_OFFER_LIST))
    },
    triggerOpen: function () {
      this.isOpen = true
      this.$emit('open')
    }
  },
  apollo: {
    user: {
      query: GET_LOCAL_USER_CURRENT_COMPANY
    }
  }
}
</script>

<style lang="stylus">
.nav-app-business { // Scope
  .v-list__group {
    &:before, &:after {
      display: none;
    }
  }

  .v-list__group__header {
    .v-list__group__header__append-icon {
      padding-left: 0;
    }
  }
}
</style>
